/* eslint-disable prettier/prettier */
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const {
  loginBegin,
  loginSuccess,
  loginErr,
  loginData,
  logoutBegin,
  logoutSuccess,
  logoutErr,
  resetBegin,
  resetSuccess,
  resetErr,
  forgotBegin,
  forgotErr,
  forgotSuccess,
  refreshBegin,
  refreshErr,
  refreshSuccess
} = actions;

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/auth/login', values);
      if (response.data.errors) {
        dispatch(loginErr(response.data.errors));
      } else {
        localStorage.setItem('logedIn', true);
        localStorage.setItem('access_token', response.data.data.token);
        dispatch(loginSuccess(true, response.data.data.profile));
        dispatch(loginData(response.data.data.profile));
        callback();
      }
    } catch (err) {
      dispatch(loginErr("Invalid Email Id and password"));
    }
  };
};

const register = (values) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/register', values);
      if (response.data.errors) {
        dispatch(loginErr('Registration failed!'));
      } else {
        dispatch(loginSuccess(false));
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      localStorage.removeItem('logedIn');
      localStorage.removeItem('access_token');
      dispatch(logoutSuccess(false));
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

const resetPassword = (values, token, callback) => {
  return async (dispatch) => {
    dispatch(resetBegin());
    try {
      const response = await DataService.post('/auth/reset', values, { "reset": token });
      if (response.data.errors) {
        dispatch(resetErr(response.data.errors));
      } else {
        dispatch(resetSuccess());
        callback();
      }
    } catch (err) {
      dispatch(resetErr("Something went wrong"));
    }
  };
}

const forgotPassword = (values, callback) => {
  return async (dispatch) => {
    dispatch(forgotBegin());
    try {
      const response = await DataService.post('/auth/forgot', values);
      if (response.data.errors) {
        dispatch(forgotErr(response.data.errors));
      } else {
        dispatch(forgotSuccess());
        callback();
      }
    } catch (err) {
      dispatch(forgotErr("Something went wrong"));
    }
  };
}

const refresh = () => {
  return async (dispatch) => {
    dispatch(refreshBegin());
    try {
      const response = await DataService.post('/auth/refresh', { token: localStorage.getItem('access_token') });
      if (response.data.errors) {
        dispatch(refreshErr(response.data.errors));
        dispatch(logOut());
      } else {
        localStorage.setItem('logedIn', true);
        localStorage.setItem('access_token', response.data.data.token);
        dispatch(refreshSuccess(response.data.data));
        dispatch(loginData(response.data.data.profile));
      }
    } catch (err) {
      dispatch(refreshErr("Invalid Auth Token"));
      dispatch(logOut());
    }
  };
};

export { login, logOut, register, resetPassword, forgotPassword, refresh };
